import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthStore } from '@program-suite/data-auth';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private authStore = inject(AuthStore);
  title = 'program-portal';

  constructor() {
    effect(() => {
      this.authStore.setApp2faStatus(true);
    });
    this.authStore.setAppPortal('program');
  }
}
